"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface GradientLinkButtonProps {
  text: string;
  href: string;
  className?: string;
}

export function GradientLinkButton({
  text,
  href,
  className,
}: GradientLinkButtonProps) {
  return (
    <a
      href={href}
      className={`relative inline-block rounded-lg overflow-hidden ${
        className || ""
      }`}
    >
      <motion.div
        className="absolute -inset-3 rounded-full bg-gradient-radial from-white/80 via-orange-400 to-orange-800 blur-[6px]"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
      ></motion.div>

      <motion.div
        className="absolute inset-0 rounded-lg bg-gradient-to-r from-orange-500 via-red-600 to-blue-500 opacity-60 blur-[12px]"
        whileHover={{ scale: 1.05 }}
      ></motion.div>

      <div className="absolute inset-0 rounded-lg bg-black/20"></div>

      <div className="relative z-10 px-6 py-3 flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.span
            key={text}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="text-white font-bold text-lg select-none"
          >
            {text}
          </motion.span>
        </AnimatePresence>
      </div>
    </a>
  );
}
